module.exports = __webpack_public_path__ + "img/efdab_px.de09a728.png";